import styled from 'styled-components';
import { mediaQueryMobileLargeMin, fontFamilySecondary } from 'styles';
import { H2, ParagraphSmall } from 'components/Typography';

export const TitleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  ${({ nbu }) =>
    nbu &&
    ` 
  flex-direction: column-reverse;
  margin-bottom: 0;
  align-items: flex-start;
  width: 100%;

  @media all and ${mediaQueryMobileLargeMin} {
    width: 55%;
  }
`}
`;

export const Title = styled(H2)`
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 8px;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 0;
  }
`;

export const Update = styled(ParagraphSmall)`
  display: flex;
  align-items: center;
  line-height: 16px;

  ${({ none }) =>
    none &&
    ` 
    display: none;
  `}

  ${({ nbu }) =>
    nbu &&
    ` 
  margin-bottom: 8px;
`}
`;
